module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'item ' + _vm.active
  }, [_c('div', {
    staticClass: "slider-wrapper"
  }, [_c('div', {
    class: 'slider-photo-' + _vm.crowdOrRais
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'show_crowdfunding',
        params: {
          id: _vm.project.id,
          title: _vm.project.title.replace(/ /g, '-')
        }
      }
    }
  }, [(_vm.project.photo.url) ? _c('img', {
    attrs: {
      "src": _vm.$server_url + _vm.project.photo.url
    }
  }) : _c('img', {
    attrs: {
      "src": require("assets/img/projectPlaceholder.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider-text-bg"
  }, [_c('div', {
    class: 'slider-text-' + _vm.crowdOrRais
  }, [_c('router-link', {
    staticClass: "category",
    attrs: {
      "to": {
        name: 'crowdfunding',
        query: {
          category: _vm.project.category.name
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.category.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "title",
    attrs: {
      "to": {
        name: 'show_crowdfunding',
        params: {
          id: _vm.project.id,
          title: _vm.project.title.replace(/ /g, '-')
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "author",
    attrs: {
      "to": {
        name: 'show_profile',
        params: {
          id: _vm.project.user.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.project.user.full_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "short-desc"
  }, [_vm._v(_vm._s(_vm.project.description))])], 1)])], 1), _vm._v(" "), _c('div', {
    class: 'slider-right-' + _vm.crowdOrRais
  }, [_c('strong', [_vm._v("CROWDFUNDING")]), _vm._v(" "), _c('p', {
    staticClass: "allready-raised"
  }, [_vm._v("$" + _vm._s(_vm._f("price")(_vm.project.collected)))]), _vm._v(" "), _c('div', {
    staticClass: "bar-goal"
  }, [_c('div', {
    staticClass: "bar-raised",
    style: ({
      width: ((_vm.project.collected / _vm.project.to_collect) * 100) + '%'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "goal-percent"
  }, [_vm._v(_vm._s(_vm.completion) + "%")]), _vm._v(" "), _c('div', {
    staticClass: "days-left"
  }, [(_vm.project.deadline && _vm.project.status === 'published') ? _c('div', [_vm._v(_vm._s(_vm._f("daysLeft")(_vm.project.deadline)) + " " + _vm._s(_vm.$t('project.daysLeft')))]) : _vm._e(), _vm._v(" "), (_vm.project.deadline && _vm.project.status === 'successful') ? _c('div', [_vm._v(_vm._s(_vm.$t('project.ended')))]) : _vm._e(), _vm._v(" "), (!_vm.project.deadline) ? _c('div', [_vm._v(_vm._s(_vm.project.duration + ' ' + _vm.$t('project.daysLeft')))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-default btn-lg button-wide",
    attrs: {
      "to": {
        name: 'show_crowdfunding',
        params: {
          id: _vm.project.id,
          title: _vm.project.title.replace(/ /g, '-')
        }
      },
      "role": "button"
    }
  }, [_vm._v("CONTRIBUTE NOW")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19322aaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Project/Slider/Slide.vue
// module id = 781
// module chunks = 1